import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Button = props => {
  const { loading, disabled, basic, children, className, buttonType, ...rest } = props;
  const isTouch =
    !!('ontouchstart' in window) || window.navigator.msMaxTouchPoints > 0;
  return (
    <button
      type="button"
      className={classnames(
        'o-button',
        {
          'o-button--basic': basic,
          'o-button--loading': loading,
          'o-button--touchable': isTouch,
          'o-button--disabled': disabled,
        },
        className,
      )}
      buttontype={buttonType}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  basic: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Button;
